import { Component, OnInit, ViewChild } from '@angular/core';
import OlMap from 'ol/Map';
import OlXYZ from 'ol/source/XYZ';
import { Tile as OlTileLayer } from 'ol/layer.js';
import OlView from 'ol/View';
import { Fill, Icon, Stroke, Style } from 'ol/style';
import { fromLonLat, get, transform } from 'ol/proj';
import { Observable } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';
import { LocationsLayer } from './layers/locations-layer';
import { Location } from '../model/location';
import { NameFormatter } from '../util/name-formatter';
import { ConfigService } from '../config.service';
import { MapRefreshService } from '../map-refresh.service';


@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  map: OlMap;
  source: OlXYZ;
  layer: OlTileLayer;
  view: OlView;
  locationsLayer: LocationsLayer;

  showLocations = true;

  constructor(protected apiService: ApiService, private router: Router, private nameFormatter: NameFormatter, protected configService: ConfigService, protected mapRefreshService: MapRefreshService) { }

  ngOnInit() {
    this.initMap();

    this.mapRefreshService.subject.subscribe(() => {
      this.refresh();
    });
  }

  onPositionSelect = (extent) => {
    this.map.getView().fit(extent);

    this.map.getView().getZoom() > 19 && this.map.getView().setZoom(19);
  }

  async initMap() {
    this.source = new OlXYZ({
      url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
    });

    this.layer = new OlTileLayer({
      source: this.source
    });

    this.locationsLayer = new LocationsLayer({}, this.nameFormatter);

    const mapConfig = await this.configService.getConfig('map').toPromise();

    this.view = new OlView({
      center: fromLonLat(mapConfig.initialCenter || [3.3617777648493, 51.3138284364]),
      zoom: mapConfig.initialZoom || 17,
    });

    this.map = new OlMap({
      target: 'map',
      layers: [this.layer, this.locationsLayer],
      view: this.view,
      renderer: 'webgl'
    });

    navigator.geolocation.getCurrentPosition((pos) => {
      this.map.getView().setCenter(fromLonLat([pos.coords.longitude, pos.coords.latitude]));
      this.map.getView().setZoom(19);
    });

    this.map.on('moveend', (e) => {
      this.refresh();
    });

  }

  refresh() {
    const coords = transform(this.map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');

    const extent = this.map.getView().calculateExtent();

    const zoom = this.map.getView().getZoom();

    this.showLocations = zoom >= 17;

    if (this.showLocations) {
      const distance = Math.ceil(Math.max(Math.abs(extent[0] - extent[2]), Math.abs(extent[1] - extent[3])));

      this.apiService.get(`locations?longitude=${coords[0]}&latitude=${coords[1]}&distance=${distance}`).subscribe((locations: Location[]) => {
        this.locationsLayer.updateLocations(locations);
      });
    } else {
      this.locationsLayer.updateLocations([]);
    }

    this.map.on('click', (e) => {
      this.map.forEachFeatureAtPixel(e.pixel, (feature) => {
        if (feature.get('location')) {
          const location: Location = feature.get('location');

          this.router.navigateByUrl(`/meld-storing/${location.id}`);
        }
      });
    });

    this.map.on('pointermove', (evt) => {
      const feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {

        document.body.style.cursor = feature.get('location') !== undefined ? 'pointer' : '';

        return feature;
      });

      document.body.style.cursor = feature ? 'cursor' : '';

    })

  }

}
